<h2 mat-dialog-title>
  {{
  'MEETING_SCHEDULER.MEETING_ACTIONS.DIALOG.CANCELLATION.CANCELLATION_TITLE'
  | translate
  }}
</h2>
<mat-dialog-content>
  <div class="row meeting-details">
    <div class="col">
      <div class="row">
        <mat-icon class="info-icon">event</mat-icon>
        <div class="col">
          <div class="bold title">
            {{
            'MEETING_SCHEDULER.MEETING_ACTIONS.DIALOG.CANCELLATION.CURRENT_MEETING'
            | translate
            }}
          </div>
          <div>{{ meeting?.date?.start | date: 'EEEE, MMM d, y' }}</div>
          <div>
            {{ meeting?.date?.start | date: 'h:mm aa' | lowercase }} -
            {{ meeting?.date?.end | date: 'h:mm aa' | lowercase }}
          </div>
        </div>
      </div>
    </div>
    @if (!meeting.isSessionEventType) {
      <div class="col">
        <div class="row">
          <mat-icon>person</mat-icon>
          <div class="col">
            <div class="bold title">
              {{
              'MEETING_SCHEDULER.MEETING_ACTIONS.DIALOG.CANCELLATION.GUEST'
              | translate
              }}
            </div>
            <div>{{ meeting?.guest }}</div>
          </div>
        </div>
      </div>
    }
  </div>
  <div class="reason-input" [formGroup]="cancellationForm">
    <mat-form-field appearance="outline">
      <mat-label>
        {{
        'MEETING_SCHEDULER.MEETING_ACTIONS.DIALOG.CANCELLATION.CANCELLATION_REASON'
        | translate
        }}
      </mat-label>
      <textarea
        matInput
        placeholder="{{
          'MEETING_SCHEDULER.MEETING_ACTIONS.DIALOG.CANCELLATION.CANCELLATION_REASON_PLACEHOLDER'
            | translate
        }}"
        formControlName="cancellationReason"
      ></textarea>
    </mat-form-field>
  </div>
</mat-dialog-content>

<mat-dialog-actions class="mat-dialog-actions">
  <button mat-stroked-button (click)="close()">
    {{
    'MEETING_SCHEDULER.MEETING_ACTIONS.DIALOG.CANCELLATION.DONT_CANCEL_BUTTON'
    | translate
    }}
  </button>

  <button
    mat-flat-button
    color="primary"
    class="reschedule-save"
    (click)="cancelMeeting()"
    >
    {{
    'MEETING_SCHEDULER.MEETING_ACTIONS.DIALOG.CANCELLATION.CANCEL_BUTTON'
    | translate
    }}
  </button>
</mat-dialog-actions>
